import { v4 as uuid } from 'uuid';
import { NodeType } from '@amplify/amp-module';

export const NodeOrder = [
  NodeType.message,
  NodeType.question,
  NodeType.buttonGroup,
  NodeType.carousel,
  NodeType.player,
  NodeType.goTo,
  NodeType.open,
  NodeType.condition,
  NodeType.plugin,
];

export const NodeSizes = {
  [NodeType.buttonGroup]: {
    width: 296,
    height: 124,
    subNodeWidth: 264,
  },
  [NodeType.carousel]: {
    width: 296,
    height: 265,
    subNodeWidth: 264,
  },
  [NodeType.condition]: {
    width: 264,
    height: 74,
  },
  [NodeType.goTo]: {
    width: 264,
    height: 92,
  },
  [NodeType.message]: {
    width: 264,
    height: 77,
  },
  [NodeType.open]: {
    width: 264,
    height: 112,
  },
  [NodeType.player]: {
    width: 264,
    height: 232,
  },
  [NodeType.plugin]: {
    width: 264,
    height: 92,
  },
  [NodeType.question]: {
    width: 296,
    height: 228,
    subNodeWidth: 264,
  },
  start: {
    width: 264,
    height: 106,
  },
  preview: {
    width: 164,
    height: 50,
  },
};

export const SubNodeType = {
  [NodeType.buttonGroup]: 'button',
  [NodeType.question]: 'button',
  [NodeType.carousel]: 'card',
};

export const SubNodesDefaultData = {
  button: {
    id: uuid(),
    buttonTexts: [''],
  },
  card: {
    id: uuid(),
    description: '',
    email: { address: '', subject: '', title: '' },
    headline: '',
    link: { title: '', url: '' },
    media: { title: '', type: '', url: '' },
  },
};

export const defaultNodesData = {
  UI: {
    node: {
      width: 264,
      data: {
        selected: false,
        hovered: false,
        conversationStarter: false,
      },
    },
    [NodeType.buttonGroup]: {
      width: NodeSizes[NodeType.buttonGroup].width,
      height: NodeSizes[NodeType.buttonGroup].height,
      shape: `${NodeType.buttonGroup}-node`,
    },
    [NodeType.carousel]: {
      width: NodeSizes[NodeType.carousel].width,
      height: NodeSizes[NodeType.carousel].height,
      shape: `${NodeType.carousel}-node`,
    },
    [NodeType.condition]: {
      height: NodeSizes[NodeType.condition].height,
      shape: `${NodeType.condition}-node`,
      children: {
        trueBranch: false,
        falseBranch: false,
      },
    },
    [NodeType.goTo]: {
      height: NodeSizes[NodeType.goTo].height,
      shape: `${NodeType.goTo}-node`,
    },
    [NodeType.message]: {
      height: NodeSizes[NodeType.message].height,
      shape: `${NodeType.message}-node`,
    },
    [NodeType.plugin]: {
      height: NodeSizes[NodeType.plugin].height,
      shape: `${NodeType.plugin}-node`,
    },
    [NodeType.question]: {
      width: NodeSizes[NodeType.question].width,
      height: NodeSizes[NodeType.question].height,
      shape: `${NodeType.question}-node`,
    },
    [NodeType.open]: {
      height: NodeSizes.open.height,
      shape: `${NodeType.open}-node`,
    },
    [NodeType.player]: {
      width: NodeSizes[NodeType.player].width,
      height: NodeSizes[NodeType.player].height,
      shape: `${NodeType.player}-node`,
    },
    start: {
      height: NodeSizes.start.height,
      shape: 'start-node',
      id: 'start-node',
      x: 0,
      y: 0,
    },
  },
  data: {
    node: () => ({
      delay: 2,
    }),
    [NodeType.buttonGroup]: () => {
      const id = uuid();

      return {
        subNodes: {
          [id]: {
            ...SubNodesDefaultData.button,
            id,
            sortIndex: 0,
          },
        },
      };
    },
    [NodeType.carousel]: () => {
      const id = uuid();

      return {
        subNodes: {
          [id]: {
            ...SubNodesDefaultData.card,
            id,
            sortIndex: 0,
          },
        },
      };
    },
    [NodeType.condition]: () => ({
      delay: 0,
      storageKey: '',
      condition: '',
      conditionValue: '',
    }),
    [NodeType.goTo]: () => ({
      delay: 0,
      conversationId: '',
      webLink: '',
    }),
    [NodeType.message]: () => ({
      html: '',
    }),
    [NodeType.open]: () => ({
      ampId: '',
      conversationId: '',
    }),
    [NodeType.player]: () => ({
      delay: 0,
      media: { title: '', url: '' },
      headline: '',
      description: '',
      storage: '',
      autoPlay: false,
    }),
    [NodeType.plugin]: () => ({
      pluginId: '',
      settings: {},
    }),
    [NodeType.question]: () => {
      const id = uuid();

      return {
        html: '',
        buttonsDelay: 2,
        subNodes: {
          [id]: {
            ...SubNodesDefaultData.button,
            id,
            sortIndex: 0,
          },
        },
      };
    },
  },
  disallowedChildren: {
    [NodeType.buttonGroup]: [],
    [NodeType.carousel]: [],
    [NodeType.condition]: [],
    [NodeType.goTo]: ['all'],
    [NodeType.message]: [],
    [NodeType.open]: [],
    [NodeType.plugin]: [],
    [NodeType.question]: [],
    [NodeType.player]: [],
    'start-node': [],
  },
};

export const START_NODE = {
  ...defaultNodesData.UI.node,
  ...defaultNodesData.UI.start,
  data: {
    ...defaultNodesData.UI.start.data,
    conversationStarter: true,
  },
};

export const roundDownTo = 10;
